(() => {
  if (customElements.get('lisa-fragrance-offer')) return;
  const source = document.getElementById('LisaFragranceOfferConfig');
  if (!source) return;
  const labels = JSON.parse(source.textContent);
  const panels = new Set();
  let cart = null;
  let request = null;
  let queued = false;
  let timer;
  const replace = (text, count) => text.replace('__COUNT__', String(count));
  const countText = count => count === 1 ? labels.countOne : replace(labels.count, count);
  const eligible = item => ['fragrances', 'fragancias'].includes(String(item.product_type || '').toLowerCase());
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }
  async function refresh() {
    if (!panels.size) return;
    if (request) { queued = true; return request; }
    request = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('cart');
        cart = await response.json();
        panels.forEach(panel => { panel.failed = false; panel.render(); });
      } catch {
        panels.forEach(panel => { panel.failed = true; panel.render(); });
      } finally {
        request = null;
        if (queued) { queued = false; schedule(); }
      }
    })();
    return request;
  }
  class FragranceOffer extends HTMLElement {
    connectedCallback() { panels.add(this); this.render(); schedule(); }
    disconnectedCallback() { panels.delete(this); }
    render() {
      const lines = (cart?.items || []).filter(eligible);
      const count = cart ? lines.reduce((sum, item) => sum + item.quantity, 0) : Number(this.dataset.count || 0);
      this.hidden = this.dataset.context === 'cart' && count === 0;
      const countLabel = this.querySelector('[data-fragrance-count]');
      const progress = this.querySelector('progress');
      if (!countLabel || !progress) return;
      countLabel.textContent = countText(count);
      progress.value = Math.min(count, 12);
      const applied = cart !== null && lines.length > 0 && count >= 12 && lines.every(item => item.final_price <= Math.max(0, item.original_price - 99));
      this.classList.toggle('fragrance-offer--unlocked', applied && !this.failed);
      if (this.failed) countLabel.textContent = labels.error;
      else if (applied) countLabel.textContent = `${countText(count)} · ${labels.unlocked}`;
    }
  }
  customElements.define('lisa-fragrance-offer', FragranceOffer);
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => {
        try { return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(new URL(entry.name).pathname); }
        catch { return false; }
      })) schedule();
    });
    try { observer.observe({type: 'resource', buffered: false}); } catch {}
  }
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('lisa:cart-added', schedule);
})();
